(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5693],{

/***/ 7018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});

var _extends2 = __webpack_require__(88239);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.Z = function (ComposedComponent) {
  var _desc, _value, _class;

  return _class = function (_React$Component) {
    (0, _inherits3.default)(WithScroll, _React$Component);

    function WithScroll(props) {
      (0, _classCallCheck3.default)(this, WithScroll);

      var _this = (0, _possibleConstructorReturn3.default)(this, (WithScroll.__proto__ || Object.getPrototypeOf(WithScroll)).call(this, props));

      _this.state = _this.calculateScroll();
      _this.debouncedHandle = (0, _throttle2.default)(_this.setNewState, 50);
      return _this;
    }

    (0, _createClass3.default)(WithScroll, [{
      key: 'calculateScroll',
      value: function calculateScroll() {
        if (typeof window === 'undefined') return { scrollX: 0, scrollY: 0 };
        var _window = window,
            scrollX = _window.scrollX,
            scrollY = _window.scrollY;

        return { scrollX: scrollX, scrollY: scrollY };
      }
    }, {
      key: 'setNewState',
      value: function setNewState() {
        this.setState(this.calculateScroll());
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('scroll', this.debouncedHandle);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.debouncedHandle);
      }
    }, {
      key: 'render',
      value: function render() {
        // console.log('rerendering scroll', this.state)
        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, this.state));
      }
    }]);
    return WithScroll;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'setNewState', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setNewState'), _class.prototype)), _class;
};

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = __webpack_require__(88572);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _throttle = __webpack_require__(23493);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 44908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 45578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 13219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_fragments_products_productListInformation_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2779);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment orderCategory on Category {\n    _id\n    name\n    products(menuId: $menuId) {\n      _id\n      categories {\n        _id\n        internalName\n      }\n      modifiers {\n        _id\n        optional\n      }\n      ...productListInformation\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject(), _data_fragments_products_productListInformation_main__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z));


/***/ }),

/***/ 74207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getOutOfStockProductsInListQuery; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getOutOfStockProductsInList(\n    $websiteId: ID\n    $productsIds: [ID]\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    outOfStockIds: outOfStockProductsInList(\n      websiteId: $websiteId\n      productsIds: $productsIds\n      storeId: $storeId\n      deliverAt: $deliverAt\n    )\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getOutOfStockProductsInListQuery = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 87714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ exactSearch; }
/* harmony export */ });
var hasAtLeastNumbers = function(phrase) {
    var numbers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    var re = /\d/g;
    var repeats = ((phrase || "").match(re) || []).length;
    return repeats >= numbers;
};
var hashHyphens = function(phrase) {
    var indexOfHyphen = phrase.indexOf("-");
    return indexOfHyphen !== -1;
};
function exactSearch(phrase) {
    return hasAtLeastNumbers(phrase) || hashHyphens(phrase);
};


/***/ }),

/***/ 87529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteLoyaltyConfig; }
/* harmony export */ });
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getActiveLoyaltyProgramConfig($websiteId: ID) {\n        loyaltyProgramConfig(websiteId: $websiteId) {\n          _id\n          name\n          active\n          maxRedeemAmount\n          minRedeemAmount\n          accumulationRate\n          blockRedeemWithCoupon\n          maxRedeemPercentage\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useWebsiteLoyaltyConfig(websiteId) {
    var ref = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId
    }), loyaltyProgramConfig = ref.loyaltyProgramConfig, loading = ref.loading, error = ref.error;
    return {
        loyaltyProgramConfig: loyaltyProgramConfig,
        loading: loading,
        error: error
    };
};


/***/ }),

/***/ 17854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebsiteCoinsImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function WebsiteCoinsImage(param) {
    var _width = param.width, width = _width === void 0 ? 20 : _width, _height = param.height, height = _height === void 0 ? 20 : _height, _svgClass = param.svgClass, svgClass = _svgClass === void 0 ? null : _svgClass;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 30 22",
        fill: "currentColor",
        className: svgClass,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.3098 21.3803C25.2138 21.3803 30 16.5942 30 10.6902C30 4.78615 25.2138 0 19.3098 0C13.4058 0 8.61963 4.78615 8.61963 10.6902C8.61963 16.5942 13.4058 21.3803 19.3098 21.3803ZM16.781 7.57122L19.3123 2.82918L21.8436 7.57122L27.033 8.56934L23.408 12.4982L24.0839 17.8571L19.3123 15.5433L14.5407 17.8571L15.2166 12.4982L11.5916 8.56934L16.781 7.57122Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.3125 2.8291L16.7812 7.57115L11.5918 8.56926L15.2168 12.4981L14.5408 17.857L19.3125 15.5432L24.0841 17.857L23.4081 12.4981L27.0331 8.56926L21.8437 7.57115L19.3125 2.8291Z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2397 0.0429048C11.9062 0.0145056 11.5684 0 11.227 0C5.0265 0 0 4.78615 0 10.6902C0 16.5942 5.0265 21.3803 11.227 21.3803C11.5218 21.3803 11.8139 21.3695 12.103 21.3483C8.38236 19.1502 5.90373 15.2191 5.90373 10.7354C5.90373 6.19702 8.4432 2.2248 12.2397 0.0429048Z",
                fill: "currentColor"
            })
        ]
    });
};


/***/ }),

/***/ 79354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShouldUseLoyaltyV2; }
/* harmony export */ });
/* harmony import */ var _hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13505);

function useShouldUseLoyaltyV2() {
    var branchName = (0,_hooks_useExperiment_experiments__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("loyalty-justo");
    return branchName === "show";
};


/***/ }),

/***/ 51680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NextOpenDate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70457);
/* harmony import */ var _helpers_websites_isStoreOpenNow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34490);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50456);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32533);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94148);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_8__);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getStoreIsOpenNow($storeId: ID!, $websiteId: ID!) {\n        store(storeId: $storeId) {\n          _id\n          schedule {\n            itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      query getStoreCapacityForNextOpenDate($storeId: ID!, $websiteId: ID!, $deliverAt: Date) {\n        store(storeId: $storeId) {\n          _id\n          nextAvailableDate\n          schedulingOrdersDays\n          hasOrderCapacity(date: $deliverAt)\n        }\n        website(websiteId: $websiteId) {\n          _id\n          limitOrdersBySlot\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function NextOpenDate(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.nextOpenDate"
    }).t;
    var storeId = props.storeId, deliverAt = props.deliverAt;
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var ref = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_6__["default"])(_templateObject()),
        variables: {
            storeId: storeId,
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        omit: !storeId
    }), storeIsOpenNow = ref.store;
    var itsOpenNow = (0,_helpers_websites_isStoreOpenNow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(storeIsOpenNow);
    var ref1 = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_6__["default"])(_templateObject1()),
        variables: {
            storeId: storeId,
            websiteId: websiteId,
            deliverAt: deliverAt
        },
        fetchPolicy: "cache-first",
        omit: itsOpenNow || !storeId
    }), store = ref1.store, website = ref1.website;
    if (itsOpenNow || !store) return null;
    var closedMessage = !(store === null || store === void 0 ? void 0 : store.hasOrderCapacity) && (website === null || website === void 0 ? void 0 : website.limitOrdersBySlot) ? "Hemos recibido todos los pedidos que podemos procesar en este momento, \xbfQu\xe9 tal si programas tu pedido para m\xe1s tarde?" : null;
    var nextDate = store.nextAvailableDate;
    var schedulingOrdersDays = store.schedulingOrdersDays;
    var className = [
        (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().container),
        props.className
    ].join(" ");
    var schedulingClassName = [
        (_styles_module_css__WEBPACK_IMPORTED_MODULE_8___default().scheduling),
        props.className
    ].join(" ");
    if (closedMessage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: schedulingClassName,
            children: closedMessage
        });
    }
    if (!nextDate) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedNow")
        });
    }
    var date = (0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(nextDate);
    if (deliverAt && (0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(deliverAt).isAfter(date) && (website === null || website === void 0 ? void 0 : website.limitOrdersBySlot)) {
        return null;
    }
    if (date.isSame((0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), "day")) {
        if (schedulingOrdersDays) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderAfter", {
                    date: date.format("HH:mm")
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedUntil", {
                date: date.format("HH:mm")
            })
        });
    }
    if (date.isSame((0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().add(1, "day"), "day")) {
        if (schedulingOrdersDays >= 2) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderTomorrow")
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedUntilTomorrow", {
                date: date.format("HH:mm")
            })
        });
    }
    if (schedulingOrdersDays >= 3) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: schedulingClassName,
            children: t("labelScheduleOrderFrom", {
                date: date.format("dddd D [de] MMMM")
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: t("labelClosedUntilDate", {
            date: date.format("LL"),
            hour: date.format("HH:mm")
        })
    });
};


/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductsContent_Category; },
  "N": function() { return /* binding */ filterUnavailableProducts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/data/fragments/categories/orderCategory.main.ts
var orderCategory_main = __webpack_require__(13219);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/index.tsx + 20 modules
var Product = __webpack_require__(35267);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/useCardsV2.tsx
var useCardsV2 = __webpack_require__(49673);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/withProductCardExperiment.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function withProductCardExperiment(Component) {
    return function WrappedComponent(props) {
        var cardsV2 = (0,useCardsV2/* default */.Z)();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, {
            cardsV2: cardsV2
        }));
    };
}
/* harmony default export */ var Category_withProductCardExperiment = (withProductCardExperiment);

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/styles.module.css
var styles_module = __webpack_require__(59540);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}







//TODO: this logic should be sent to backend when hideNotAvailableProducts option is divided into to functionalities
var filterUnavailableProducts = function(hideNotAvailableProducts) {
    return function(product) {
        if (hideNotAvailableProducts && product.isOutOfStock) {
            return false;
        }
        if (!product.availabilityAt) return false;
        if (product.availabilityAt.notAvailableMessage) return true;
        return !!product.availabilityAt.available;
    };
};
var _Component;
var Category = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Category, _superClass);
    var _super = _createSuper(Category);
    function Category() {
        _classCallCheck(this, Category);
        return _super.apply(this, arguments);
    }
    var _proto = Category.prototype;
    _proto.getProducts = function getProducts() {
        var filterUnavailableProductsFn = filterUnavailableProducts(this.props.hideNotAvailableProducts);
        var productList = this.props.category.products.filter(filterUnavailableProductsFn);
        if (this.props.sorting) {
            if (this.props.sorting.type === "price") {
                productList = orderBy_default()(productList, function(product) {
                    return product.availabilityAt.finalPrice;
                }, [
                    this.props.sorting.order
                ]);
            }
            if (this.props.sorting.type === "name") {
                productList = orderBy_default()(productList, [
                    "name"
                ], [
                    this.props.sorting.order
                ]);
            }
            if (this.props.sorting.type === "timesPurchased") {
                productList = orderBy_default()(productList, [
                    "timesPurchased"
                ], [
                    this.props.sorting.order
                ]);
            }
        }
        return productList;
    };
    _proto.renderProducts = function renderProducts() {
        var _this = this;
        var className = this.props.productsLayout === "compact" ? ({
            mobile: "col-xs-6",
            v1: "col-xs-6 col-md-3",
            v2: "col-xs-3 col-md-2"
        })[this.props.layout] : ({
            mobile: "col-xs-12",
            v1: "col-xs-12 col-md-6",
            v2: "col-xs-6 col-md-4"
        })[this.props.layout];
        className += " menuProductCol";
        if (this.props.cardsV2) {
            className = "";
        }
        return this.getProducts().map(function(product) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* default */.Z, {
                    productsLayout: _this.props.productsLayout,
                    productCardDesign: _this.props.productCardDesign,
                    hidePrice: _this.props.hidePrice,
                    // @ts-expect-error ts-migrate(2739) FIXME: Type 'orderCategory_products' is missing the follo... Remove this comment to see the full error message
                    product: product,
                    menuId: _this.props.menuId
                })
            }, product._id);
        });
    };
    _proto.render = function render() {
        var category = this.props.category;
        var cardsV2 = this.props.cardsV2;
        if (this.getProducts().length === 0) return null;
        var productsStyle = cardsV2 ? "flex flex-row flex-wrap gap-4 justify-center md:justify-start" : (styles_module_default()).products;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).container,
                id: "t111_".concat(category._id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).name,
                        children: category.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: productsStyle,
                        children: cardsV2 ? this.renderProducts() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: this.renderProducts()
                        })
                    })
                ]
            })
        });
    };
    return Category;
}(_Component = react.Component);
Category.fragment = orderCategory_main/* default */.Z;
/* harmony default export */ var ProductsContent_Category = (Category_withProductCardExperiment(Category));


/***/ }),

/***/ 57769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WebsiteCoin; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage.tsx
var WebsiteCoinsImage = __webpack_require__(17854);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/useWebsiteCoinsBalanceNavBar.main.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteCoinsBalance($websiteId: ID) {\n        me {\n          _id\n          websiteCoinsBalance(websiteId: $websiteId)\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useWebsiteCoinsBalanceNavBar(websiteId) {
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: !websiteId,
        fetchPolicy: "cache-first"
    }), me = ref.me, loading = ref.loading, error = ref.error;
    return {
        me: me,
        loading: loading,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/WebsiteCoin.tsx





function WebsiteCoin(param) {
    var websiteId = param.websiteId, config = param.config, _asLink = param.asLink, asLink = _asLink === void 0 ? false : _asLink, _bannerCustomClass = param.bannerCustomClass, bannerCustomClass = _bannerCustomClass === void 0 ? "" : _bannerCustomClass;
    var me = useWebsiteCoinsBalanceNavBar(websiteId).me;
    if (!(me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) && (me === null || me === void 0 ? void 0 : me.websiteCoinsBalance) !== 0) return null;
    var bannerClasses = (0,classnames/* default */.Z)("flex py-3 px-7 rounded-lg text-white justify-center primaryBackgroundColor", bannerCustomClass, {
        "cursor-pointer": asLink
    });
    var bannerContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoinsImage/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-lg ml-2",
                children: [
                    "Tienes ",
                    me.websiteCoinsBalance,
                    " ",
                    config.name
                ]
            })
        ]
    });
    return asLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/justoloyalty",
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: bannerClasses,
            children: bannerContent
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: bannerClasses,
        children: bannerContent
    });
};


/***/ }),

/***/ 27624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WebsiteCoins; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5434);
/* harmony import */ var _helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63601);
/* harmony import */ var _hooks_useUserId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77883);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var _page_components_CheckoutV3_hooks_useWebsiteLoyaltyConfig_main__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87529);
/* harmony import */ var _page_components_CheckoutV3_sections_useShouldUseLoyaltyV2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79354);
/* harmony import */ var _page_components_CheckoutV3_sections_WebsiteCoins_WebsiteCoinsCount_WebsiteCoinsImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17854);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32533);
/* harmony import */ var _WebsiteCoin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57769);










function WebsiteCoins() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("website", {
        keyPrefix: "loyalty"
    }).t;
    var showJustoLoyaltyV2 = (0,_page_components_CheckoutV3_sections_useShouldUseLoyaltyV2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var userId = (0,_hooks_useUserId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,_page_components_CheckoutV3_hooks_useWebsiteLoyaltyConfig_main__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(websiteId), config = ref.loyaltyProgramConfig;
    var loginViaAuth = (0,_helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_1__/* .useLoginViaAuthWindow */ .l)("loyalty");
    if (!showJustoLoyaltyV2) return null;
    if (!(config === null || config === void 0 ? void 0 : config.active) || !websiteId) return null;
    if (!userId) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: function() {
            return loginViaAuth();
        },
        className: "flex sm:flex-row primaryBackgroundColor text-white py-4 px-7 rounded-md relative w-full max-w-3xl items-center cursor-pointer mb-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_CheckoutV3_sections_WebsiteCoins_WebsiteCoinsCount_WebsiteCoinsImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col ml-2 mr-7 mb-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            "\xa1",
                            t("getPoints"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-bold",
                                children: config.name
                            }),
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-xs font-medium",
                        children: t("join")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ml-auto text-2xl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_9__/* .MdKeyboardArrowRight */ .AeI, {})
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full max-w-4xl mb-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_WebsiteCoin__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            config: config,
            websiteId: websiteId,
            asLink: true
        })
    });
};


/***/ }),

/***/ 68156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Products; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/data/queries/preferences/getMyOrderPreferencesSlim.main.ts
var getMyOrderPreferencesSlim_main = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/data/queries/website/websiteMenuInformation.main.tsx + 1 modules
var websiteMenuInformation_main = __webpack_require__(41372);
// EXTERNAL MODULE: ./src/helpers/misc/hasWebpSupport.ts
var hasWebpSupport = __webpack_require__(6909);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/Order/NextOpenDate/NextOpenDate.main.tsx
var NextOpenDate_main = __webpack_require__(51680);
// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
// EXTERNAL MODULE: ./src/page-components/Order/useProductsLayout.ts
var useProductsLayout = __webpack_require__(66218);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/helpers/misc/getOrderPath.ts
var getOrderPath = __webpack_require__(81820);
// EXTERNAL MODULE: ./src/helpers/misc/getQueryObject.ts
var getQueryObject = __webpack_require__(62280);
// EXTERNAL MODULE: ./src/helpers/misc/scrollTo.ts
var scrollTo = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withScroll.js
var withScroll = __webpack_require__(7018);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx + 1 modules
var StoreName = __webpack_require__(68441);
// EXTERNAL MODULE: ./node_modules/lodash/flatten.js
var flatten = __webpack_require__(85564);
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Bar/index.tsx
var Bar = __webpack_require__(98812);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/BrandBar/index.tsx
var BrandBar = __webpack_require__(10238);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Brands/index.tsx + 1 modules
var Brands = __webpack_require__(51888);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Categories/index.tsx + 1 modules
var Categories = __webpack_require__(7078);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/index.tsx + 1 modules
var Category = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Filters/index.tsx
var Filters = __webpack_require__(82544);
// EXTERNAL MODULE: ./src/helpers/misc/exactSearch.ts
var exactSearch = __webpack_require__(87714);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/getProducts.ts

function getProducts(products, filter, Fuse, sort) {
    var exact = (0,exactSearch/* default */.Z)(filter);
    var fuse = new Fuse(products, {
        fieldNormWeight: 1,
        keys: [
            {
                name: "name",
                weight: 1
            },
            {
                name: "nicknames",
                weight: 1
            },
            {
                name: "description",
                weight: 0.5
            }
        ],
        threshold: exact ? 0 : 0.45
    });
    var productList = fuse.search(filter).map(function(product) {
        return product.item;
    });
    return productList;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Loading/index.tsx
var Loading = __webpack_require__(31143);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/NoBrandDivider/index.tsx
var NoBrandDivider = __webpack_require__(26642);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx + 35 modules
var SelectProduct = __webpack_require__(34948);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/WebsiteCoins/index.tsx
var WebsiteCoins = __webpack_require__(27624);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/styles.module.css
var styles_module = __webpack_require__(31616);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


























var _class;
var _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    typeof ProductsContentProps === "undefined" ? Object : ProductsContentProps
]), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function);
var ProductsContent = _class = (0,withScroll/* default */.Z)(_class = _dec1(_class = _dec((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ProductsContent, _Component);
    var _super = _createSuper(ProductsContent);
    function ProductsContent(props) {
        _classCallCheck(this, ProductsContent);
        var _this;
        _this = _super.call(this, props);
        _this.lastProductId = null;
        _this.categoriesRefs = {};
        _this.state = {
            scrollOffset: 0,
            filter: "",
            sorting: null,
            lastScroll: null,
            searchProducts: []
        };
        var productId = props.router.query.productId;
        if (productId) {
            _this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        return _this;
    }
    var _proto = ProductsContent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var scrollCategorySlug = this.props.router.query.categoria;
        var search = this.props.router.query.search;
        if (scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        if (search) {
            this.setState({
                filter: search
            });
            this.memoizeProducts();
        }
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
        // Avoid rerendering everytime the scroll changes
        if (this.props.scrollY !== nextProps.scrollY) {
            if (this.shouldUpdateActiveCategory(nextProps.scrollY)) {
                return true;
            }
            return false;
        }
        return true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var ref;
        this.setScrollToId();
        this.checkActiveCategory(this.props.scrollY);
        this.scrollTo();
        var scrollCategorySlug = this.props.router.query.categoria;
        if (scrollCategorySlug && this.state.lastScroll !== scrollCategorySlug) {
            this.setScrollOnClick(scrollCategorySlug);
        }
        var search = this.props.router.query.search;
        if (search && search !== prevProps.router.query.search) {
            this.setState({
                filter: search
            });
        }
        // If either the query changed or the previous memoization attempt failed, memoize the products
        if (search && (search !== prevProps.router.query.search || !((ref = this.state.searchProducts) === null || ref === void 0 ? void 0 : ref.length))) {
            this.memoizeProducts();
        }
    };
    _proto.setScrollOnClick = function setScrollOnClick(category) {
        this.setState({
            scrollToSlug: category,
            lastScroll: category
        });
    };
    _proto.setScrollToId = function setScrollToId() {
        var categories = this.props.categories;
        var _state = this.state, scrollToSlug = _state.scrollToSlug, scrollTo1 = _state.scrollTo;
        if (!categories) return;
        if (!scrollToSlug || scrollTo1) return;
        var clean = function(text) {
            return text.toLowerCase().replace(/ /g, "-");
        };
        var scrollCategory = categories.items.find(function(item) {
            return slugify_default()(clean(item.name)) === clean(scrollToSlug);
        });
        if (scrollCategory) {
            this.setState({
                scrollTo: scrollCategory._id,
                scrollToSlug: null
            });
        }
    };
    _proto.getVisibleCategories = function getVisibleCategories() {
        if (!this.props.categories) return [];
        return this.props.categories.items.filter(function(category) {
            return category.products.length;
        });
    };
    _proto.getCategoriesBarOffset = function getCategoriesBarOffset() {
        if (this.props.layout === "v1") {
            return 70;
        } else {
            return 70 + 50;
        }
    };
    _proto.scrollTo = function scrollTo2() {
        if (!this.props.categories) return;
        if (!this.state.scrollTo) return;
        if (!this.categoriesRefs[this.state.scrollTo]) {
            console.log("scroll to category not found");
            return;
        }
        if (!this.categoriesRefs[this.state.scrollTo].offsetTop) {
            var _this = this;
            console.log("scroll to category not mounted, trying again");
            setTimeout(function() {
                return _this.scrollTo();
            }, 400);
            return;
        }
        var top = this.categoriesRefs[this.state.scrollTo].offsetTop - this.getCategoriesBarOffset() - this.state.scrollOffset;
        (0,scrollTo/* default */.Z)({
            top: top
        });
        this.setState({
            scrollTo: null
        });
    };
    _proto.shouldUpdateActiveCategory = function shouldUpdateActiveCategory(scrollY) {
        var activeCategoryId = this.getActiveCategory(scrollY);
        if (this.state.activeCategoryId !== activeCategoryId) {
            return true;
        }
        return false;
    };
    _proto.checkActiveCategory = function checkActiveCategory(scrollY) {
        if (this.shouldUpdateActiveCategory(scrollY)) {
            var activeCategoryId = this.getActiveCategory(scrollY);
            this.setState({
                activeCategoryId: activeCategoryId
            });
        }
    };
    _proto.getActiveCategory = function getActiveCategory(scrollY) {
        if (!this.props.categories) return;
        var activeCategoryId = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = _step.value, categoryId = _value._id;
                var element = this.categoriesRefs[categoryId];
                if (!element) continue;
                var position = element.offsetTop;
                if (position - this.getCategoriesBarOffset() - 10 < scrollY) {
                    activeCategoryId = categoryId;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return activeCategoryId;
    };
    _proto.getSelectedProduct = function getSelectedProduct() {
        if (!this.props.categories) return null;
        var productId = this.lastProductId || this.props.router.query.productId;
        if (!productId) return null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.props.categories.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var products = _step.value.products;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var product = _step1.value;
                        if (product._id === productId) {
                            return product;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _proto.renderCategories = function renderCategories() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var categories = this.getVisibleCategories();
        var lastBrandId = null;
        var isMultiBrand = this.props.website.isMultiBrand;
        return categories.map(function(category) {
            var _this1 = _this;
            var brand = null;
            if (category.brand && category.brand._id !== lastBrandId) {
                brand = category.brand;
                lastBrandId = brand._id;
            }
            var dividerContent = !category.brand && lastBrandId ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoBrandDivider/* default */.Z, {}) : null;
            var brandContent = brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBar/* default */.Z, {
                brand: brand
            }) : null;
            if (!category.brand && lastBrandId) {
                lastBrandId = null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    isMultiBrand && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            brandContent,
                            dividerContent
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: function(ref) {
                            return _this1.categoriesRefs[category._id] = ref;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {
                            productsLayout: _this.props.productsLayout,
                            layout: _this.props.layout,
                            productCardDesign: _this.props.productCardDesign,
                            category: category,
                            menuId: _this.props.menuId,
                            hidePrice: _this.props.hidePrice,
                            select: function(select) {
                                return _this1.setState({
                                    select: select,
                                    open: true
                                });
                            },
                            sorting: _this.state.sorting,
                            hideNotAvailableProducts: _this.props.website.hideNotAvailableProducts
                        })
                    })
                ]
            }, category._id);
        });
    };
    _proto.renderSelect = function renderSelect() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct/* default */.Z, {
                allowEdit: false,
                product: this.getSelectedProduct(),
                open: !!(this.props.router.query.productId && this.getSelectedProduct()),
                close: function() {
                    var query = _objectSpread({}, (0,getQueryObject/* default */.Z)(_this.props.router));
                    delete query.productId;
                    _this.props.router.push({
                        pathname: (0,getOrderPath/* default */.Z)(_this.props.router, _this.props.website),
                        query: query
                    }, null, {
                        scroll: false
                    });
                }
            })
        });
    };
    _proto.renderBar = function renderBar() {
        var _this = this;
        var visibleCategories = this.getVisibleCategories();
        if (!visibleCategories.length) return;
        return this.props.website && this.props.website.isMultiBrand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Brands/* default */.Z, {
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo3) {
                return _this.setState({
                    scrollTo: scrollTo3,
                    scrollOffset: 120
                });
            },
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories/* default */.Z, {
            activeCategoryId: this.state.activeCategoryId,
            categories: this.getVisibleCategories(),
            scrollTo: function(scrollTo4) {
                return _this.setState({
                    scrollTo: scrollTo4
                });
            },
            layout: this.props.layout,
            onClick: function() {
                return _this.setState({
                    filter: null
                });
            }
        });
    };
    _proto.memoizeProducts = function memoizeProducts() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref1, categories, Fuse, allProducts, searchProducts;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        categories = (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1.items;
                        if (!(!categories || categories.length === 0)) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _ctx.next = 6;
                        return __webpack_require__.e(/* import() */ 4221).then(__webpack_require__.bind(__webpack_require__, 74221));
                    case 6:
                        Fuse = _ctx.sent.default;
                        allProducts = uniqBy_default()(flatten_default()(categories.map(function(cat) {
                            return cat.products;
                        })), "_id");
                        searchProducts = getProducts(allProducts, _this.state.filter, Fuse, _this.state.sorting);
                        if (!(searchProducts.length === 0)) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        _this.setState({
                            searchProducts: searchProducts
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.renderSearchResults = function renderSearchResults() {
        var _this = this;
        if (!this.props.categories) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
        var category = {
            _id: "search",
            name: "Resultados",
            products: this.state.searchProducts
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Category/* default */.Z, {
            productsLayout: this.props.productsLayout,
            layout: this.props.layout,
            category: category,
            menuId: this.props.menuId,
            hidePrice: this.props.hidePrice,
            select: function(select) {
                return _this.setState({
                    select: select,
                    open: true
                });
            },
            productCardDesign: this.props.productCardDesign,
            sorting: this.state.sorting
        });
    };
    _proto.render = function render() {
        var _this = this;
        var productId = this.props.router.query.productId;
        if (productId) {
            this.lastProductId = typeof productId === "string" ? productId : productId[0];
        }
        var products = this.state.filter ? this.renderSearchResults() : this.renderCategories();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).container + " " + (styles_module_default())["container_" + this.props.layout],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* default */.Z, {
                        layout: this.props.layout,
                        filter: this.state.filter,
                        setFilter: function(filter) {
                            _this.setState({
                                filter: filter
                            });
                            if (filter) {
                                _this.memoizeProducts();
                            }
                        },
                        children: this.renderBar()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: (styles_module_default()).containerWebsiteCoins,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteCoins/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (styles_module_default()).containerLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).containerIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                                isOnMenu: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).containerFilter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters/* default */.Z, {
                                    sorting: this.state.sorting,
                                    setSorting: function(sorting) {
                                        return _this.setState({
                                            sorting: sorting
                                        });
                                    }
                                })
                            })
                        })
                    ]
                }),
                this.props.layout === "v2" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        this.props.nextOpenDate,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        products
                    ]
                }) : products,
                this.renderSelect()
            ]
        });
    };
    return ProductsContent;
}(react.Component)) || _class) || _class) || _class) || _class;
/* harmony default export */ var Products_ProductsContent = ((0,router.withRouter)(ProductsContent));

// EXTERNAL MODULE: ./src/data/fragments/categories/orderCategory.main.ts
var orderCategory_main = __webpack_require__(13219);
// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/categories/categoriesForWebsite.main.ts
function categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function categoriesForWebsite_main_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                categoriesForWebsite_main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getCategoriesAndProductsWeb_cached(\n    $websiteId: ID\n    $menuId: ID\n    $format: String\n    $storeId: ID\n    $deliverAt: Date\n  ) {\n    categories(websiteId: $websiteId) {\n      items {\n        _id\n        ...orderCategory\n        brand {\n          _id\n          name\n          link\n          menuImage {\n            _id\n            url\n          }\n          categoriesImage {\n            _id\n            url\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var categoriesForRestaurantQuery = (0,lib["default"])(_templateObject(), orderCategory_main/* default */.Z);
function getCategoriesForWebsite(_) {
    return _getCategoriesForWebsite.apply(this, arguments);
}
function _getCategoriesForWebsite() {
    _getCategoriesForWebsite = categoriesForWebsite_main_asyncToGenerator(regeneratorRuntime.mark(function _callee(param) {
        var websiteId, menuId, _format, format, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    websiteId = param.websiteId, menuId = param.menuId, _format = param.format, format = _format === void 0 ? "webp" : _format;
                    _ctx.next = 3;
                    return getClient().query({
                        query: categoriesForRestaurantQuery,
                        variables: {
                            websiteId: websiteId,
                            menuId: menuId,
                            format: format
                        }
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.categories);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getCategoriesForWebsite.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useCategoriesAndProducts.ts



function useCategoriesAndProducts(param) {
    var websiteId = param.websiteId, menuId = param.menuId, format = param.format, _preloadedCategories = param.preloadedCategories, preloadedCategories = _preloadedCategories === void 0 ? {
        items: []
    } : _preloadedCategories, storeId = param.storeId, deliverAt = param.deliverAt;
    // On the serverside, we skip this query and return the categories loaded at getStaticProps
    // These categories are obtained from the store default menu
    var result = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: categoriesForRestaurantQuery,
        variables: {
            websiteId: websiteId,
            menuId: menuId,
            format: format,
            storeId: storeId,
            deliverAt: deliverAt
        },
        omit: (0,isServerSide/* default */.Z)()
    });
    if ((0,isServerSide/* default */.Z)() || !result.data) {
        return {
            categories: preloadedCategories
        };
    }
    return result;
};

// EXTERNAL MODULE: ./src/data/queries/stock/getOutOfStockProductsInList.ts
var getOutOfStockProductsInList = __webpack_require__(74207);
// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(44908);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/useSetOutOfStockProducts.ts




function useSetOutOfStockProducts(param) {
    var websiteId = param.websiteId, categories = param.categories, storeId = param.storeId, deliverAt = param.deliverAt;
    var productsIds = [];
    var cats = categories ? categories.items : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = category.products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var product = _step1.value;
                    productsIds.push(product._id);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var outOfStockIds = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getOutOfStockProductsInList/* getOutOfStockProductsInListQuery */.q,
        variables: {
            websiteId: websiteId,
            productsIds: uniq_default()(productsIds),
            storeId: storeId,
            deliverAt: deliverAt
        },
        partial: true,
        omit: productsIds.length === 0 || !storeId || (0,isServerSide/* default */.Z)()
    }).outOfStockIds;
    if (!outOfStockIds || !outOfStockIds.length) return {
        outOfStockIds: []
    };
    return {
        outOfStockIds: outOfStockIds
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/index.tsx
function Products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var ProductsContentMemo = /*#__PURE__*/ react.memo(Products_ProductsContent);
function Products(props) {
    var preloadedCategories = props.preloadedCategories;
    var website = (0,websiteMenuInformation_main/* useWebsiteMenuInformation */.g9)().website;
    var data = (0,getMyOrderPreferencesSlim_main/* useMyOrderPreferencesSlim */.b)(website._id, {
        partial: false
    }).data;
    var ref;
    var ref1 = (ref = data === null || data === void 0 ? void 0 : data.preferences) !== null && ref !== void 0 ? ref : {}, menuId = ref1.menuId, storeId = ref1.storeId, deliverAt = ref1.deliverAt, shouldHidePrice = ref1.shouldHidePrice;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var format = (0,hasWebpSupport/* default */.Z)() ? "webp" : "jpeg";
    var categories = useCategoriesAndProducts({
        websiteId: websiteId,
        menuId: menuId,
        format: format,
        preloadedCategories: preloadedCategories,
        storeId: storeId,
        deliverAt: deliverAt
    }).categories;
    var design = (0,websiteMenuInformation_main/* useWebsiteMenuInformation */.g9)().design;
    var productCardDesign = design === null || design === void 0 ? void 0 : design.design.productCardDesign;
    var layout = (0,useLayout/* default */.Z)();
    /**
   * TODO: Reverted changed from nicoleguerrero/ep-1039 because the main query is cached,
   * so a change in the stock is not reflected automatically en the query.
   * It is needed to separate the query in the stable values (cached) and the dynamic ones (non cached)
   * before deleting this logic
   * cc Niko
   */ var outOfStockIds = useSetOutOfStockProducts({
        websiteId: websiteId,
        categories: categories,
        storeId: storeId,
        deliverAt: deliverAt
    }).outOfStockIds;
    var memoizedCategories = (0,react.useMemo)(function() {
        if (!((categories === null || categories === void 0 ? void 0 : categories.items) && outOfStockIds)) return categories;
        var newCategories = {
            items: []
        };
        newCategories.items = categories.items.map(function(category) {
            var newProducts = category.products.map(function(product) {
                return Products_objectSpread({}, product, {
                    isOutOfStock: outOfStockIds.includes(product._id)
                });
            });
            return Products_objectSpread({}, category, {
                products: newProducts
            });
        });
        return newCategories;
    }, [
        outOfStockIds,
        categories
    ]);
    var productsLayout = (0,useProductsLayout/* default */.Z)(website);
    var nextOpenDate = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextOpenDate_main/* default */.Z, {
        deliverAt: deliverAt,
        storeId: storeId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsContentMemo, {
        layout: layout,
        menuId: menuId,
        hidePrice: shouldHidePrice,
        productsLayout: productsLayout,
        storeId: storeId,
        nextOpenDate: nextOpenDate,
        website: website,
        categories: memoizedCategories,
        productCardDesign: productCardDesign
    });
};


/***/ }),

/***/ 94148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1p4i0Q6FHN2JmlK1-Aq9gW","scheduling":"z5vfYbOpyPAIVionHNmzq _1p4i0Q6FHN2JmlK1-Aq9gW"};

/***/ }),

/***/ 59540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jU7LHQAFgsjy0t2QSVFUG","name":"fahAOBEtcJXL_vQiK4fah appTitle","products":"Jw-GQ1r-mZqgls-nIWFlc","menuProductCol":"_2gA2q6LFKNg_089WQ7zI7k"};

/***/ }),

/***/ 31616:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MGVMHYuV2u5Mnd4iJrB5z","order":"_1rc5Zr7uGJ08A7khxcq_Cw","container_v2":"_3FD032u_YFLQKVcG3ziO6E","containerIcon":"_2Oh-2Bzj3YvGTCi-dCDB8E","containerWebsiteCoins":"_25miMneexJVc-xJkhJkBJ","containerLabel":"VCCkn5d7s1AgefhPPUSFA","containerFilter":"_4k1tbxlHpljsPDTqQ7AH4"};

/***/ })

}]);